@if (property(); as property) {
  @for (listingId of [property.id]; track listingId) {
  <div class="carousel-wrapper position-relative">
    <div
      [id]="carouselId + property.id"
      class="carousel slide ltr-mode"
      (slid.bs.carousel)="onSlideChanged($event)"
      data-bs-touch="false"
      data-bs-interval="false"
    >
      @if (displayIndicator && property.pictures.length > 1) {
        <div class="carousel-indicators thumbs-wrapper">
          <div class="thumbs-viewport">
            <div class="thumbs-track" [style.transform]="'translateX(-' + translateX + 'px)'">
              @for (pic of property.pictures; track pic; let i = $index) {
                <button
                  type="button"
                  loading="lazy"
                  [attr.data-bs-target]="'#' + carouselId + property.id"
                  [attr.data-bs-slide-to]="i"
                  [class.active]="i === activeIndex"
                  (click)="onThumbClick(i)"
                  class="thumb-btn"
                >
                  <img [src]="pic" class="thumb d-block" />
                </button>
              }
            </div>
          </div>
        </div>
      }
      <div class="carousel-inner rounded">
        @if (property.pictures !== undefined && property.pictures.length > 0) {
          <div
            class="carousel-item"
            *ngFor="let pic of property.pictures; let i = index"
            [class.active]="i === 0"
          >
            <div class="image-wrapper">
              <img
                [src]="pic"
                loading="lazy"
                class="d-block w-100"
                [ngClass]="{ cover: imagClass === 'cover', contain: imagClass === 'contain' }"
                alt="{{ property.title }}"
                (click)="openModal(i)"
              />
              @if (listingCard && carouselId !== 'propertyModal') {
                <span class="listing-sale-badge">{{
                  property.isForRent ? ('FOR_RENT' | translate) : ('FOR_SALE' | translate)
                }}</span>
              }
              <!-- Sold overlay -->
              @if (property.isExpired) {
                <div class="sold-overlay">
                  <span class="sold-text text-primary">{{ 'EXPIRED' | translate }}</span>
                </div>
              } @else if (property.status === statuses.Sold) {
                <div class="sold-overlay">
                  <span class="sold-text text-primary">{{ 'SOLD' | translate }}</span>
                </div>
              } @else {
                @if (displayLikeButton && carouselId !== 'propertyModal') {
                  <span
                    class="position-absolute top-0 end-0 text-dark bg-primary rounded like-button m-2"
                    (click)="toggleLike($event)"
                  >
                    @if (localProperty(); as localProperty) {
                      <span class="badge fs-6 p-1 text-dark">
                        <i [class]="localProperty.liked ? 'bi bi-heart-fill' : 'bi bi-heart'"></i>
                      </span>
                    }
                  </span>
                }
              }
              @if (carouselId !== 'propertyModal') {
                <span
                  class="position-absolute top-0 m-2"
                  [class.start-0]="!listingCard"
                  [class.listing-price-badges]="listingCard"
                >
                  <strong class="bg-primary text-dark rounded mx-1 badge fs-6 p-1"
                    ><app-price [price]="property.price"></app-price
                  ></strong>
                  @if (!listingCard) {
                    <span class="bg-primary text-dark rounded badge fs-6 p-1">{{
                      property.isForRent ? ('FOR_RENT' | translate) : ('FOR_SALE' | translate)
                    }}</span>
                  }
                </span>
              }
            </div>
          </div>
        }
      </div>
      @if (property.pictures.length > 1) {
        <div class="image-counter">{{ activeIndex + 1 }} / {{ property.pictures.length }}</div>
        <button
          class="carousel-control-prev"
          type="button"
          [attr.data-bs-target]="'#' + carouselId + property.id"
          data-bs-slide="prev"
          (click)="next($event)"
        >
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          [attr.data-bs-target]="'#' + carouselId + property.id"
          data-bs-slide="next"
          (click)="next($event)"
        >
          <span class="carousel-control-next-icon"></span>
        </button>
      }
    </div>
  </div>
}
}
